import { z } from "zod";

import {
  getLocalStorageItem,
  jsonCodec,
  removeLocalStorageItem,
  setLocalStorageItem,
  useLocalStorage,
} from "~/pld/hooks/use-local-storage";

const ACTIVE_COMPANY_BRANCH_KEY = "ACTIVE_COMPANY_BRANCH_ID";

const companyBranchIdCodec = jsonCodec(z.uuid());

export const getActiveCompanyBranchId = () => {
  const companyBranchId = getLocalStorageItem(ACTIVE_COMPANY_BRANCH_KEY);

  if (!companyBranchId) {
    throw new Error("Active company branch id not found");
  }

  try {
    return companyBranchIdCodec.decode(companyBranchId);
  } catch (error) {
    clearActiveCompanyBranchId();
    throw error;
  }
};

export const getActiveCompanyBranchIdSilently = () => {
  const companyBranchId = getLocalStorageItem(ACTIVE_COMPANY_BRANCH_KEY);

  if (companyBranchId) {
    const decodedCompanyBranchId =
      companyBranchIdCodec.safeDecode(companyBranchId);

    if (decodedCompanyBranchId.success) {
      return decodedCompanyBranchId.data;
    }
  }

  clearActiveCompanyBranchId();
  return null;
};

export const useActiveCompanyBranchId = (initialValue?: string) => {
  return useLocalStorage(ACTIVE_COMPANY_BRANCH_KEY, initialValue, z.uuid());
};

export function setActiveCompanyBranchId(companyBranchId: string) {
  setLocalStorageItem(
    ACTIVE_COMPANY_BRANCH_KEY,
    companyBranchIdCodec.encode(companyBranchId),
  );
}

export function clearActiveCompanyBranchId() {
  removeLocalStorageItem(ACTIVE_COMPANY_BRANCH_KEY);
}
